<template>
  <div class="container">
    <Header
      :title="'Section 1: About You'"
      :details="
        'This information helps us better match you with opportunities to share your unique story. Please provide personal contact details (cell phone or personal email), rather than work or school contact information, which may be temporary. Fields where a red * appears are required.'
      "
      :includeDisclaimer="false"
      :errorMessage="missingInfo ? 'Missing Information!' : null"
      :errorDetails="
        missingInfo ? 'All fields marked with a red * must be provided!' : null
      "
    />
    <div class="row">
      <div class="col-md-12 col-lg-6 mt-2">
        <label>
          First Name
          <span style="color: red;">*</span>
        </label>
        <input
          type="text"
          :class="
            `form-control ${
              values.firstName.length === 0 && missingInfo
                ? 'border-danger'
                : ''
            }`
          "
          placeholder="First Name"
          :value="values.firstName"
          @keyup="e => handleValueChanged('firstName', e.target.value)"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-2">
        <label>
          Last Name
          <span style="color: red;">*</span>
        </label>
        <input
          type="text"
          :class="
            `form-control ${
              values.lastName.length === 0 && missingInfo ? 'border-danger' : ''
            }`
          "
          placeholder="Last Name"
          :value="values.lastName"
          @keyup="e => handleValueChanged('lastName', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 mt-2">
        <label for="gender" class="col-form-label">
          Gender
          <span style="color: red;">*</span>
        </label>
        <input
          type="text"
          :class="
            `form-control ${
              values.gender.length === 0 && missingInfo ? 'border-danger' : ''
            }`
          "
          placeholder="Gender"
          :value="values.gender"
          @keyup="e => handleValueChanged('gender', e.target.value)"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-2">
        <label for="section1_dob" class="col-form-label">
          Date of Birth
          <span style="color: red;">*</span>
        </label>
        <input
          type="date"
          :class="
            `form-control ${
              values.dob.length === 0 && missingInfo ? 'border-danger' : ''
            }`
          "
          :value="values.dob"
          @change="e => handleValueChanged('dob', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">Race/Ethnicity</label>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.raceCheckboxWhite"
              @change="
                e => handleValueChanged('raceCheckboxWhite', e.target.checked)
              "
            />
            White
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.raceCheckboxHispanic"
              @change="
                e =>
                  handleValueChanged('raceCheckboxHispanic', e.target.checked)
              "
            />
            Hispanic or Latino
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.raceCheckboxBlack"
              @change="
                e => handleValueChanged('raceCheckboxBlack', e.target.checked)
              "
            />
            Black or African American
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.raceCheckboxAsian"
              @change="
                e => handleValueChanged('raceCheckboxAsian', e.target.checked)
              "
            />
            Asian / Pacific Islander
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.raceCheckboxNativeAmerican"
              @change="
                e =>
                  handleValueChanged(
                    'raceCheckboxNativeAmerican',
                    e.target.checked
                  )
              "
            />
            Native American
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="values.raceCheckboxOther"
              @change="
                e => handleValueChanged('raceCheckboxOther', e.target.checked)
              "
            />
            Other
          </label>
        </div>
        <input
          type="text"
          class="form-control mt-1"
          placeholder="Other"
          :value="values.raceOther"
          @keyup="e => handleValueChanged('raceOther', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">Sexual Orientation</label>
        <input
          type="text"
          class="form-control"
          placeholder="Sexual Orientation"
          :value="values.sexualOrientation"
          @keyup="e => handleValueChanged('sexualOrientation', e.target.value)"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">Occupation</label>
        <input
          type="text"
          class="form-control"
          placeholder="Occupation"
          :value="values.job"
          @keyup="e => handleValueChanged('job', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">Address</label>
        <input
          type="text"
          class="form-control"
          placeholder="Address"
          :value="values.address"
          @keyup="e => handleValueChanged('address', e.target.value)"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">Apt. Number</label>
        <input
          type="text"
          class="form-control"
          placeholder="Apt. Number"
          :value="values.aptNumber"
          @keyup="e => handleValueChanged('aptNumber', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-4 mt-2">
        <label class="col-form-label">
          City
          <span style="color: red;">*</span>
        </label>
        <input
          type="text"
          :class="
            `form-control ${
              values.city.length === 0 && missingInfo ? 'border-danger' : ''
            }`
          "
          placeholder="City"
          :value="values.city"
          @keyup="e => handleValueChanged('city', e.target.value)"
        />
      </div>
      <div class="col-md-12 col-lg-4 mt-2">
        <label class="col-form-label">
          State
          <span style="color: red;">*</span>
        </label>
        <select
          :class="
            `form-control ${
              values.state === 'State' && missingInfo ? 'border-danger' : ''
            }`
          "
          :value="values.state"
          @change="e => handleValueChanged('state', e.target.value)"
        >
          <option default>State</option>
          <option>Alabama</option>
          <option>Alaska</option>
          <option>Arizona</option>
          <option>Arkansas</option>
          <option>California</option>
          <option>Colorado</option>
          <option>Connecticut</option>
          <option>Delaware</option>
          <option>D.C.</option>
          <option>Florida</option>
          <option>Georgia</option>
          <option>Hawaii</option>
          <option>Idaho</option>
          <option>Illinois</option>
          <option>Indiana</option>
          <option>Iowa</option>
          <option>Kansas</option>
          <option>Kentucky</option>
          <option>Louisiana</option>
          <option>Maine</option>
          <option>Maryland</option>
          <option>Massachusetts</option>
          <option>Michigan</option>
          <option>Minnesota</option>
          <option>Mississippi</option>
          <option>Missouri</option>
          <option>Montana</option>
          <option>Nebraska</option>
          <option>Nevada</option>
          <option>New Hampshire</option>
          <option>New Jersey</option>
          <option>New Mexico</option>
          <option>New York</option>
          <option>North Carolina</option>
          <option>North Dakota</option>
          <option>Ohio</option>
          <option>Oklahoma</option>
          <option>Oregon</option>
          <option>Pennsylvania</option>
          <option>Rhode Island</option>
          <option>South Carolina</option>
          <option>South Dakota</option>
          <option>Tennessee</option>
          <option>Texas</option>
          <option>Utah</option>
          <option>Vermont</option>
          <option>Virginia</option>
          <option>Washington</option>
          <option>West Virginia</option>
          <option>Wisconsin</option>
          <option>Wyoming</option>
        </select>
      </div>
      <div class="col-md-12 col-lg-4 mt-2">
        <label class="col-form-label">
          Zip Code
          <span style="color: red;">*</span>
        </label>
        <input
          type="text"
          :class="
            `form-control ${
              values.zipCode.length === 0 && missingInfo ? 'border-danger' : ''
            }`
          "
          placeholder="Zip Code"
          :value="values.zipCode"
          @keyup="e => handleValueChanged('zipCode', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">
          Phone Number
          <span style="color: red;">*</span>
        </label>
        <input
          type="tel"
          :class="
            `form-control ${
              values.phone.length === 0 && missingInfo ? 'border-danger' : ''
            }`
          "
          placeholder="Phone Number"
          :value="values.phone"
          @keyup="e => handleValueChanged('phone', e.target.value)"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">
          Email Address
          <span style="color: red;">*</span>
        </label>
        <input
          type="email"
          :class="
            `form-control ${
              (values.email.length === 0 && missingInfo) || emailsMismatch
                ? 'border-danger'
                : ''
            }`
          "
          placeholder="Email Address"
          :value="values.email"
          @keyup="e => handleValueChanged('email', e.target.value)"
        />
        <small v-if="emailDisclaimerShown" class="form-text text-muted">
          Changing your email address will revoke access to your application
          from this account. Click
          <a href="#" @click="showEmailDisclaimer">here</a> for more
          information.
        </small>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-lg-6 mt-2" />
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">
          Confirm Email Address
          <span style="color: red;">*</span>
        </label>
        <input
          type="email"
          :class="
            `form-control ${
              (values.confirmEmail.length === 0 && missingInfo) ||
              emailsMismatch
                ? 'border-danger'
                : ''
            }`
          "
          placeholder="Confirm Email Address"
          :value="values.confirmEmail"
          @keyup="e => handleValueChanged('confirmEmail', e.target.value)"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <label>
          <strong>Other languages spoken and proficiency</strong>
        </label>
        <textarea
          class="form-control"
          rows="3"
          :value="values.languagesSpoken"
          @keyup="e => handleValueChanged('languagesSpoken', e.target.value)"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-lg-6">
        <label>
          <strong
            >Are you a member of or involved with any local or national
            organizations?</strong
          >
          <br />
          <em
            >For example, a local sexual assault service provider, faith-based
            organization, or community group.</em
          >
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="involvementRadio"
              :checked="values.involvementRadio1"
              @change="
                e => handleValueChanged('involvementRadio1', e.target.checked)
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="involvementRadio"
              :checked="values.involvementRadio2"
              @change="
                e => handleValueChanged('involvementRadio2', e.target.checked)
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <label>If yes, please list any organizations:</label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.organizationNames"
          @keyup="e => handleValueChanged('organizationNames', e.target.value)"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-lg-6">
        <label
          :class="
            values.militaryRadio1 === values.militaryRadio2 && missingInfo
              ? 'text-danger'
              : ''
          "
        >
          <strong>
            Do you currently or have you ever served in the US military?
            <span style="color: red;">*</span>
          </strong>
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="militaryRadio"
              :checked="values.militaryRadio1"
              @change="
                e => handleValueChanged('militaryRadio1', e.target.checked)
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="militaryRadio"
              :checked="values.militaryRadio2"
              @change="
                e => handleValueChanged('militaryRadio2', e.target.checked)
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <label
          >If yes, please provide the branch you were apart of and your time
          served:</label
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">Branch</label>
        <input
          type="text"
          class="form-control"
          placeholder="Branch"
          :value="values.militaryBranch"
          @keyup="e => handleValueChanged('militaryBranch', e.target.value)"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-2">
        <label class="col-form-label">Time Served</label>
        <input
          type="text"
          class="form-control"
          placeholder="Time served"
          :value="values.militaryTime"
          @keyup="e => handleValueChanged('militaryTime', e.target.value)"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-lg-6">
        <label>
          <strong>Were you active duty when you were assaulted?</strong>
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="assaultedOnDutyRadio"
              :checked="values.assaultedOnDutyRadio1"
              @change="
                e =>
                  handleValueChanged('assaultedOnDutyRadio1', e.target.checked)
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="assaultedOnDutyRadio"
              :checked="values.assaultedOnDutyRadio2"
              @change="
                e =>
                  handleValueChanged('assaultedOnDutyRadio2', e.target.checked)
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-lg-6">
        <label>
          <strong>Do you have any physical disabilities?</strong>
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="physicalDisabilityRadio"
              :checked="values.physicalDisabilityRadio1"
              @change="
                e =>
                  handleValueChanged(
                    'physicalDisabilityRadio1',
                    e.target.checked
                  )
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="physicalDisabilityRadio"
              :checked="values.physicalDisabilityRadio2"
              @change="
                e =>
                  handleValueChanged(
                    'physicalDisabilityRadio2',
                    e.target.checked
                  )
              "
            />
            No
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="physicalDisabilityRadio"
              :checked="values.physicalDisabilityRadio3"
              @change="
                e =>
                  handleValueChanged(
                    'physicalDisabilityRadio3',
                    e.target.checked
                  )
              "
            />
            Prefer not to answer
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">If yes, please specify:</label>
        <input
          type="text"
          class="form-control"
          placeholder="Disability"
          :value="values.physicalDisability"
          @keyup="e => handleValueChanged('physicalDisability', e.target.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Application/SectionHeader";
import { SectionOne } from "@/typings/application";

export default {
  name: "sectionOne",
  components: {
    Header
  },
  props: {
    values: {
      type: SectionOne,
      requried: true,
      default: () => {
        return new SectionOne();
      }
    },
    onValueChanged: {
      type: Function,
      requried: true,
      default: () => {}
    },
    missingInfo: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      }
    },
    emailDisclaimerShown: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      }
    },
    showEmailDisclaimer: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  computed: {
    emailsMismatch() {
      return this.values.email.length > 0 || this.values.confirmEmail.length > 0
        ? this.values.email !== this.values.confirmEmail
        : false;
    }
  },
  methods: {
    handleValueChanged(name, value) {
      this.onValueChanged("section1", name, value);
      if (name === "raceOther") {
        // Ensure that raceCheckboxOther's value is representative of the
        // raceOther value.
        this.onValueChanged("section1", "raceCheckboxOther", value.length > 0);
      } else if (name.startsWith("physicalDisabilityRadio")) {
        const radio = name.split("Radio");
        const index = parseInt(radio[1]);
        for (let i = 1; i <= 3; i++) {
          if (index !== i) {
            this.onValueChanged(
              "section1",
              `physicalDisabilityRadio${i}`,
              !value
            );
          }
        }
      } else if (name.includes("Radio")) {
        // Ensures that only one radio within a radio group is selected at a
        // time.
        const radio = name.split("Radio");
        const index = (parseInt(radio[1]) % 2) + 1;
        this.onValueChanged("section1", `${radio[0]}Radio${index}`, false);
      }
    }
  }
};
</script>
